import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Plus, X, Check } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { inputCls, btnPrimary, btnGhost, cardCls } from "./styles";
import { ServiceIcon, ICON_NAMES } from "../ServiceIcon";

const EMPTY = { title: "", desc: "", icon: "Wrench", order: 0, visible: true };

export const ServicesTab = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/admin/services").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (form.id) await api.put(`/admin/services/${form.id}`, form);
      else await api.post("/admin/services", form);
      toast.success("تم الحفظ");
      setForm(null);
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("حذف هذه الخدمة؟")) return;
    try {
      await api.delete(`/admin/services/${id}`);
      toast.success("تم الحذف");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-5">
        <div className="text-sm text-zinc-500">{items.length} خدمة</div>
        <button data-testid="service-add-btn" onClick={() => setForm({ ...EMPTY, order: items.length + 1 })} className={`${btnPrimary} flex items-center gap-1.5`}>
          <Plus className="w-4 h-4" /> إضافة خدمة
        </button>
      </div>

      {form && (
        <form data-testid="service-form" onSubmit={save} className={`${cardCls} mb-5 space-y-3 border-yellow-400/40`}>
          <div className="grid sm:grid-cols-2 gap-3">
            <input data-testid="service-title-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="اسم الخدمة *" className={inputCls} required />
            <select data-testid="service-icon-select" value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })} className={inputCls}>
              {ICON_NAMES.map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
          <textarea data-testid="service-desc-input" value={form.desc} onChange={(e) => setForm({ ...form, desc: e.target.value })} placeholder="وصف الخدمة" rows={2} className={inputCls} />
          <div className="flex flex-wrap items-center gap-4">
            <label className="flex items-center gap-2 text-sm text-zinc-400">
              الترتيب
              <input data-testid="service-order-input" type="number" value={form.order} onChange={(e) => setForm({ ...form, order: Number(e.target.value) })} className={`${inputCls} w-20`} />
            </label>
            <label className="flex items-center gap-2 text-sm text-zinc-400">
              <input data-testid="service-visible-check" type="checkbox" checked={form.visible} onChange={(e) => setForm({ ...form, visible: e.target.checked })} className="accent-yellow-400 w-4 h-4" />
              ظاهرة في الموقع
            </label>
            <div className="flex gap-2 mr-auto">
              <button type="submit" data-testid="service-save-btn" className={`${btnPrimary} flex items-center gap-1.5`}><Check className="w-4 h-4" /> حفظ</button>
              <button type="button" data-testid="service-cancel-btn" onClick={() => setForm(null)} className={btnGhost}><X className="w-4 h-4" /></button>
            </div>
          </div>
        </form>
      )}

      <div className="space-y-3">
        {items.map((s) => (
          <div key={s.id} data-testid={`service-row-${s.id}`} className={`${cardCls} flex items-center gap-4`}>
            <span className="w-10 h-10 shrink-0 rounded-lg bg-yellow-400/10 border border-yellow-400/30 flex items-center justify-center text-yellow-400">
              <ServiceIcon name={s.icon} className="w-5 h-5" />
            </span>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-white text-sm flex items-center gap-2">
                {s.title}
                {!s.visible && <span className="text-[10px] text-zinc-500 border border-zinc-700 rounded-full px-2 py-0.5">مخفية</span>}
              </div>
              <div className="text-xs text-zinc-500 truncate">{s.desc}</div>
            </div>
            <button data-testid={`service-edit-${s.id}`} onClick={() => setForm(s)} className="text-zinc-400 hover:text-yellow-400 p-1.5 transition-colors"><Pencil className="w-4 h-4" /></button>
            <button data-testid={`service-delete-${s.id}`} onClick={() => del(s.id)} className="text-zinc-400 hover:text-red-400 p-1.5 transition-colors"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
